import {ReactElement, useEffect} from 'react';
import {GuestRoute} from '../auth/guards/guest-route';
import {RegisterPage} from '../auth/ui/register-page';
import {useSettings} from '../core/settings/use-settings';
import {CustomPageLayout} from '@common/custom-page/custom-page-layout';
import {LoginPageWrapper} from '@common/auth/ui/login-page-wrapper';
import {FullPageLoader} from '@common/ui/progress/full-page-loader';

/**
 * Главная задана как HTML-проект платформы — полная перезагрузка `/`, иначе SPA отрисует лендинг.
 * Добавлено: 2026-05-03 (тип homepage userProject из настроек).
 */
function ReloadPlatformUserProjectHome() {
  useEffect(() => {
    window.location.replace('/');
  }, []);

  return <FullPageLoader screen />;
}

interface DynamicHomepageProps {
  homepageResolver?: (type?: string) => ReactElement;
}
export function DynamicHomepage({homepageResolver}: DynamicHomepageProps) {
  const {homepage} = useSettings();

  if (homepage?.type === 'loginPage') {
    return (
      <GuestRoute>
        <LoginPageWrapper />
      </GuestRoute>
    );
  }

  if (homepage?.type === 'registerPage') {
    return (
      <GuestRoute>
        <RegisterPage />
      </GuestRoute>
    );
  }

  if (homepage?.type === 'customPage') {
    const slug =
      homepage.value != null && homepage.value !== ''
        ? String(homepage.value)
        : undefined;
    return <CustomPageLayout slug={slug} />;
  }

  if (homepage?.type === 'userProject') {
    return <ReloadPlatformUserProjectHome />;
  }

  return homepageResolver?.(homepage?.type) || null;
}
